import PKRStaking from './PKRStaking.json';
import PKRTokenERC20 from './PKRTokenERC20.json';
import PKRTokenBEP20 from './PKRTokenBEP20.json';

export const ABI = {
  PKRStaking: PKRStaking.abi,
  PKRTokenERC20: PKRTokenERC20.abi,
  PKRTokenBEP20: PKRTokenBEP20.abi,
};
